/**
 * Un badge personnel que la personne a déjà ne devient professionnel qu'avec son accord (ses recharges seraient visibles
 * par l'organisation). Le serveur demande cet accord par e-mail et garde le badge personnel en attendant ; l'écran le dit
 * avant d'enregistrer, et après. L'inverse ne demande rien : la personne en est seulement prévenue.
 */

/** Le nom de la personne qui a le badge. */
export function holderName(token) {
  const customer = token?.customer || {}
  return [customer.firstname, customer.lastname].filter(Boolean).join(' ') || customer.email || ''
}

/** Cet enregistrement va demander son accord : badge déjà à la personne, personnel, rien de demandé, coché pro, même titulaire. */
export function asksConsent(before, after) {
  const holder = before?.customer?.id
  if (!holder || before.corporate || before.professionalRequest || !after?.corporate) return false
  const nextHolder = after.customerId ?? holder
  return nextHolder === holder
}

/** Il redevient personnel : la personne est prévenue. */
export function becomesPersonal(before, after) {
  return !!before?.customer?.id && (!!before.corporate || !!before.professionalRequest) && after && !after.corporate
}

export async function confirmProfessional(vm, token) {
  return !!(await vm.$dialog.confirm({
    title: vm.$t('rfid.professional-consent.confirm-title'),
    text: vm.$t('rfid.professional-consent.confirm-text', { name: holderName(token) }),
    persistent: true,
    actions: {
      false: { text: vm.$t('cancel'), color: 'secondary' },
      true: { text: vm.$t('rfid.professional-consent.confirm-send'), color: 'primary' },
    },
  }))
}

/** Ce qu'on dit après l'enregistrement, ou rien. */
export function savedNotice(vm, before, after) {
  if (asksConsent(before, after)) return vm.$t('rfid.professional-consent.requested', { name: holderName(before) })
  if (becomesPersonal(before, after)) return vm.$t('rfid.professional-consent.became-personal', { name: holderName(before) })
  return null
}
